// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HiRK4","label":"styles_label__1ALRe"};